import { type ReactQuery } from 'cms-api'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box, Flex } from 'components/Layout'
import { useUserAuth } from 'providers/userAuth'
import { COLOR_INTENT, SPACE } from 'Theme'
import { ReadyToJoinSection } from './sections/ReadyToJoinSection'
import { ShopAnywhereSection } from './sections/ShopAnywhereSection'
import { TradeDoneRightSection } from './sections/TradeDoneRightSection'
import { TradeHero } from './sections/TradeHero'
import { TradePerksSection } from './sections/TradePerksSection'
import { TradePlatformSection } from './sections/TradePlatformSection'
import { TradeForm } from './TradeForm'
import {
  TRADE_FORM_CONSENT_BLOCKS,
  TRADE_FORM_DESCRIPTION_BLOCKS,
} from './tradePerksData'

type TradeProps = {
  marketplaceBrandsWidget: ReactQuery.WidgetsBrandsWidgetComponent | null
}

export const Trade = ({ marketplaceBrandsWidget }: TradeProps) => {
  const { isExpertSignedIn, isPageLoading } = useUserAuth()
  const isMember = Boolean(isExpertSignedIn)

  return (
    <Box width="100%" backgroundColor={COLOR_INTENT.WIDGETS.TRADE_PAGE.PAGE_BG}>
      <TradeHero isMember={isMember} isAuthLoading={Boolean(isPageLoading)} />
      <TradePlatformSection
        marketplaceBrands={marketplaceBrandsWidget?.brands ?? null}
      />
      <TradeDoneRightSection />
      <ShopAnywhereSection />
      <TradePerksSection isMember={isMember} />
      {!isMember && (
        <>
          <ReadyToJoinSection />
          <Box position="relative">
            <Box
              position="absolute"
              top={{ MOBILE: '-94px', TABLET: '-60px' }}
              id="form"
            />
            <Flex justifyContent="center">
              <Box
                px={{ MOBILE: SPACE.PX_16, TABLET: SPACE.PX_60 }}
                py={{ MOBILE: '48px', TABLET: SPACE.PX_80 }}
              >
                <TradeForm
                  description={TRADE_FORM_DESCRIPTION_BLOCKS}
                  consent={TRADE_FORM_CONSENT_BLOCKS}
                />
              </Box>
            </Flex>
          </Box>
        </>
      )}
    </Box>
  )
}

Trade.seoProps = {
  description:
    'One Trade Program. One membership. Shop Interior Define, The Citizenry, and 200+ curated brands with exclusive trade pricing, dedicated support, and perks that grow with your business.',
}

Trade.getLayout = (page) =>
  getPublicLayout(page, {
    isFullWidth: true,
  })
